import { Button, cn } from "@tellescope/ui";
import { i18n } from "@tellescope/i18n";
import type { FormResponseCategory } from "../../../../shared/schema";

const categoryLabels: Record<FormResponseCategory, string> = {
  submitted: i18n.t("Submitted", { ns: "forms" }),
  unsubmitted: i18n.t("Unsubmitted", { ns: "forms" }),
  all: i18n.t("All", { ns: "forms" }),
};

export interface CategorySelectorProps {
  categories: FormResponseCategory[];
  selectedCategory: FormResponseCategory;
  onSelectCategory: (category: FormResponseCategory) => void;
}

export const CategorySelector = ({ categories, selectedCategory, onSelectCategory }: CategorySelectorProps) => {
  return (
    <div className="flex gap-1 p-1 bg-muted rounded-lg">
      {categories.map((category) => (
        <Button
          key={category}
          variant="ghost"
          size="sm"
          className={cn(
            "flex-1 h-8 text-xs font-medium",
            selectedCategory === category
              ? "bg-background text-foreground shadow-sm hover:bg-background"
              : "text-muted-foreground hover:bg-transparent hover:text-foreground"
          )}
          onClick={() => onSelectCategory(category)}
        >
          {categoryLabels[category]}
        </Button>
      ))}
    </div>
  );
};
